import React, {useState} from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {Grid2, ListItemIcon} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {DeleteOutline, KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";
import ListItemButton from "@mui/material/ListItemButton";
import styles
    from "../../../../../components/societyAdmin/societyAdminArticles/addArticleModal/AddArticleModal.module.css";
import Button from "@mui/material/Button";
import {
    ProductImageDTO
} from "../../../../../components/societyAdmin/societyAdminArticles/societyAdminArticlesList/SocietyAdminArticlesList";
import useSociety from "../../../../../hooks/useSociety";
import Typography from "@mui/material/Typography";

interface ProductImageForListDTO extends ProductImageDTO {
    isNew: boolean;
    file?: File;
}

const ArticlesImagesDefinition = () => {

    const {society} = useSociety();

    const [productImages, setProductImages] = useState<ProductImageForListDTO[]>([]);

    const swapProductImage = (productImage: ProductImageForListDTO, goesDown: boolean) => {
        const indexProductImage = productImages.indexOf(productImage);

        if (indexProductImage === -1) {
            return;
        }

        if (indexProductImage === productImages.length - 1 && goesDown) {
            return;
        }

        if (indexProductImage === 0 && !goesDown) {
            return;
        }

        const indexPreviousProductImage = indexProductImage + (goesDown ? 1 : -1);

        setProductImages((prevProductImages) => {
            const newProductImages = prevProductImages.map((item) => ({...item}))

            const otherProductImage = {...newProductImages[indexPreviousProductImage]};
            const toDownProductImage = {...newProductImages[indexProductImage]};

            const otherProductImageOrder = otherProductImage.imageOrder;
            const toDownProductImageOrder = toDownProductImage.imageOrder;

            newProductImages[indexPreviousProductImage] = {...toDownProductImage, imageOrder: otherProductImageOrder};
            newProductImages[indexProductImage] = {...otherProductImage, imageOrder: toDownProductImageOrder};

            return newProductImages
        })
    }

    const handleUploadImage = (file: File) => {
        setProductImages((prevProductImages: ProductImageForListDTO[]) => {
            let lastOrder = 0;
            if (prevProductImages.length > 0) {
                lastOrder = prevProductImages[prevProductImages.length - 1].imageOrder;
            }
            return [...prevProductImages, {
                id: Math.floor(Math.random() * 10000000),
                imageOrder: lastOrder + 1,
                imageName: file.name,
                isNew: true,
                file: file,
            }
            ];
        })
    }

    const handleDeleteImage = (productImage: ProductImageForListDTO) => {
        setProductImages((prevProductImages) => {
            const indexOfElementToDelete = prevProductImages.indexOf(productImage);

            if (indexOfElementToDelete === -1) {
                return prevProductImages;
            }

            const copy = [...prevProductImages];

            copy.splice(indexOfElementToDelete, 1);

            return copy;
        })
    }

    return (
        <Box>

            <Typography
                variant={"firstVariant"}
                textAlign={"justify"}
                mb={2}
            >
                Bien qu'optionnelles, les images d'illustration permettront aux utilisateurs de visualiser le produit en question.
                Tu peux en ajouter jusqu'à 5 par article. Tu peux également définir l'ordre dans lequel elles seront affichées.
            </Typography>

            <List dense sx={{bgcolor: 'background.paper'}}>
                {productImages.sort((productImageA, productImageB) => productImageA.imageOrder - productImageB.imageOrder)
                    .map((productImage) => {
                        return (
                            <ListItem
                                disableGutters={true}
                                sx={{mb: 2}}
                                key={productImage.id}
                                secondaryAction={
                                    <Grid2 container>
                                        <Grid2 size={4}>
                                            <IconButton
                                                aria-label="Remove"
                                                variant="thirdVariant"
                                                onClick={() => {
                                                    swapProductImage(productImage, false);
                                                }}
                                            >
                                                <KeyboardArrowUp
                                                    sx={{
                                                        fontSize: {xs: '25px', sm: '25px'},
                                                        padding: '0px',
                                                    }}
                                                />

                                            </IconButton>
                                        </Grid2>
                                        <Grid2 size={4}>
                                            <IconButton
                                                aria-label="Remove"
                                                variant="thirdVariant"
                                                onClick={() => {
                                                    swapProductImage(productImage, true);
                                                }}
                                            >
                                                <KeyboardArrowDown
                                                    sx={{
                                                        fontSize: {xs: '25px', sm: '25px'},
                                                        padding: '0px',
                                                    }}
                                                />

                                            </IconButton>
                                        </Grid2>
                                        <Grid2 size={4}>
                                            <IconButton
                                                aria-label="Remove"
                                                variant="thirdVariant"
                                                onClick={() => {
                                                    handleDeleteImage(productImage);
                                                }}
                                            >
                                                <DeleteOutline
                                                    sx={{
                                                        fontSize: {xs: '25px', sm: '25px'},
                                                        padding: '0px',
                                                    }}
                                                />

                                            </IconButton>


                                        </Grid2>
                                    </Grid2>

                                }
                                disablePadding
                            >
                                <ListItemButton sx={{pl: '0px'}}>
                                    <ListItemIcon>
                                        <Box
                                            maxHeight={'80px'}
                                            maxWidth={'110px'}
                                        >
                                            <img
                                                className={styles.illustration_image}
                                                src={
                                                    productImage.isNew ? productImage.file && URL.createObjectURL(productImage.file) :
                                                        `https://looty.ch:8443/api/v1/societies/${society.id}/products/${1}/images/${productImage.id}`
                                                }
                                            />
                                        </Box>
                                    </ListItemIcon>
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
            </List>

            <input
                accept="image/*, android/force-camera-workaround"
                capture
                style={{display: 'none'}}
                id="raised-button-file"
                type="file"
                onChange={(event) => {
                    if (event.target.files && event.target.files.length > 0) {
                        if (event.target.files[0].size > 10485760) {
                            alert('Fichier trop volumineux. Max 10Mb.')
                        } else {
                            handleUploadImage(event.target.files[0]);
                        }
                    }
                }}
            />

            {productImages && productImages.length < 5 && (
                <label htmlFor="raised-button-file">
                    <Button variant="secondVariant" component="span" sx={{mb: 2}}>
                        Ajouter une image
                    </Button>
                </label>
            )}

            {productImages && productImages.length >= 5 && (
                <label>Nombre maximal d'images atteint</label>
            )}
        </Box>
    );
}

export default ArticlesImagesDefinition